export default __webpack_public_path__ + "static/stavien-sinovialna-stava-124f8a4605868ed0f4d3e4ef6090d003.jpg";